import {Injectable, NgZone} from "@angular/core";
import {HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {EMPTY, Observable, of} from "rxjs";
import {switchMap} from 'rxjs/operators';
import {Router} from "@angular/router";

@Injectable()
export class TokenExpiredInterceptorService implements HttpInterceptor {


  constructor(private ngZone: NgZone, private router: Router) {
  }


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(switchMap((value) => {
        if (value.type === HttpEventType.Response) {
          if (!window.location.href.includes('email-verification') &&
            value.body?.data && value.body.data == "tokenExpired") {

            this.ngZone.run(() => {
              this.router.navigate(["email-verification"]).then(() => {
              });
            });

            return EMPTY;
          }
        }
        return of(value);
      }));
  }


}





